export default class RecapMajModaleController {
	static $inject = ['ModalService', 'notification', '$translate', '$filter', '$uibModal', 'RecapMajModaleService'];
	constructor(ModalService, notification, $translate, $filter, $uibModal, RecapMajModaleService) {
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.$uibModal = $uibModal;
		this.RecapMajModaleService = RecapMajModaleService;
		this.files = [];
		this.loading = false;
	}

	async $onInit() {
		await this.loadFiles();
	}

	async loadFiles() {
		this.startLoading();
		try {
			this.files = await this.RecapMajModaleService.getFiles();
		} catch (error) {
			this.notification.error(this.$translate.instant(error.data));
		} finally {
			this.stopLoading();
		}
	}
	download(file) {
		try {
			this.RecapMajModaleService.downloadFile(file);
		} catch (error) {
			this.notification.error(this.$translate.instant(error.data));
		}
	}

	cancel() {
		this.dismiss();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
